import { render, staticRenderFns } from "./SliderText.vue?vue&type=template&id=aa0d0c2c&scoped=true&"
import script from "./SliderText.vue?vue&type=script&lang=ts&"
export * from "./SliderText.vue?vue&type=script&lang=ts&"
import style0 from "./SliderText.vue?vue&type=style&index=0&id=aa0d0c2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d0c2c",
  null
  
)

export default component.exports